module.exports = __webpack_public_path__ + "static/img/cqcsupport.858b898d.png";